/* lm-reveal — reveal [data-reveal] elements on scroll. Replaces Webflow IX2 scroll effects.
   Adds `js` to <html> so lm-tokens.css can set the hidden start state only when JS + motion are on.
   Respects prefers-reduced-motion and re-scans on theme-editor section loads. */
(() => {
  if (window.__lmReveal) return;
  window.__lmReveal = true;
  const root = document.documentElement;
  root.classList.add('js');

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const revealAll = () =>
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => el.classList.add('is-revealed'));

  if (!('IntersectionObserver' in window) || reduce.matches) {
    revealAll();
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  const observe = () => document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => io.observe(el));
  observe();
  document.addEventListener('shopify:section:load', observe);
})();
